import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'zop-time-picker',
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        FormsModule,
        FormlyModule
    ],
    template: `
    <mat-form-field appearance="outline">
      <mat-label>{{ to.label }}</mat-label>
      <input
        matInput
        [type]="'time'"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [required]="to.required!"
        placeholder="{{ to.placeholder }}"
      />
    </mat-form-field>
    <!-- Validation Messages -->
    <div *ngIf="formControl.invalid" class="error-messages">
        <div *ngFor="let errorKey of getErrorKeys()">
          {{ getErrorMessage(errorKey) }}
        </div>
    </div>
  `,
    styles: [
        `
      .error-messages {
        color: red;
        font-size: 12px;
        margin-top: -12px;
        margin-bottom: 12px;
      }
    `,
    ]
})
export class TimepickerComponent extends FieldType<FieldTypeConfig> {
  
  getErrorKeys(): string[] {
    return this.formControl?.errors ? Object.keys(this.formControl.errors) : [];
  }

  getErrorMessage(errorKey: string): string {
    try{
      if (this.formControl?.errors && this.formControl?.errors[errorKey].message) {
        return this.formControl?.errors[errorKey].message;
      }
    }catch(error){
      console.error('Exception in time-picker.component => getErrorMessage()');
      console.error(error);
    }
    // Default message if no custom message is defined
    return `Invalid value: ${errorKey}`;
  }
}